import React from 'react';
import AISolutions from '../../components/AI/Ai.jsx';

const AI = () => {
  return (
    <>
      {/* Footer Section  */}
      <section>
        <AISolutions />
      </section>
    </>
  );
};

export default AI;
